import Swiper from 'swiper/bundle';

jQuery(function ($) {

  const gallery = new Swiper('.gallery',{
    loop: true,
    navigation: {
      nextEl: '.gallery-next',
      prevEl: '.gallery-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
  });

  
  var x = 0,
      container = $('.hero__topics'),
      items = container.find('li'),
      containerHeight = 0,
      numberVisible = 13;

if(!container.find('li:first').hasClass("first")){
  container.find('li:first').addClass("first");
}

items.each(function(){
  if(x < numberVisible){
    containerHeight = containerHeight + $(this).outerHeight();
    x++;
  }
});

container.css({ height: containerHeight, overflow: "hidden" });
  
function vertCycle() {
  var firstItem = container.find('li.first').html();
  container.append('<li>'+firstItem+'</li>');
  firstItem = '';
  container.find('li.first').animate({ marginTop: "-30px" }, 500, function(){  $(this).remove(); container.find('li:first').addClass("first"); });
}

setInterval(vertCycle,2000);



var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
if ("IntersectionObserver" in window) {
  var lazyVideoObserver = new IntersectionObserver(function (
    entries,
    observer
  ) {
    entries.forEach(function (video) {
      if (video.isIntersecting) {
        for (var source in video.target.children) {
          var videoSource = video.target.children[source];
          if (
            typeof videoSource.tagName === "string" &&
            videoSource.tagName === "SOURCE"
          ) {
            videoSource.src = videoSource.dataset.src;
          }
        }

        video.target.load();
        video.target.classList.remove("lazy");
        lazyVideoObserver.unobserve(video.target);
      }
    });
  });

  lazyVideos.forEach(function (lazyVideo) {
    lazyVideoObserver.observe(lazyVideo);
  });
}


$("#check-all input").click(function () {
  var form = $(this).parents(".wpcf7");
  var checkBoxes = $(form).find(".check-group input");
  checkBoxes.prop("checked", true);
});

$(".check-group input").on("click", function () {
  var form = $(this).parents(".wpcf7");
  $(form).find("#check-all input").prop("checked", false);
});

$(".wpcf7-response-output").each(function () {
  $(this).insertBefore($(this).parent(".wpcf7-form").find(".form-section"));
});

});